import { Paper, Typography } from '@mui/material';

const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
        // Extract date from the payload data
        const date = new Date(payload[0].payload.dateSampled).toLocaleDateString();

        return (
            <Paper sx={{ p: 1, border: '1px solid #ccc' }
            }>
                <Typography variant="body2" > <strong>Date: </strong> {date}</Typography >
                {
                    payload.map((entry: any) => (
                        <Typography
                            key={entry.name}
                            variant="body2"
                            sx={{ color: entry.color }}
                        >
                            <strong>{entry.name}: </strong> {entry.value}
                        </Typography>
                    ))}
            </Paper>
        );
    }
    return null;
};

export default CustomTooltip;